// src/store/slices/animeFeatures.slice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { animeService } from '../../services/TopAnimes/top-anime.service'
import { getByDay } from '../../services/schedule.service'
import { classicsService } from '../../services/ClassicAnimes/classic-anime.service'

/* ---------------------------------------------------------- */
/* ------------------ Async Thunks -------------------------- */
/* ---------------------------------------------------------- */

// 🔹 שליפת לוח שידורים לפי יום
export const fetchAnimeScheduleByDay = createAsyncThunk(
  'animeFeatures/fetchScheduleByDay',
  async (day, thunkAPI) => {
    try {
      const data = await getByDay(day)
      return { day, data }
    } catch (error) {
      console.error(`❌ שגיאה בשליפת לוח שידורים ליום ${day}:`, error)
      return thunkAPI.rejectWithValue(error.message || 'שגיאה לא ידועה')
    }
  }
)

// 🔹 שליפת אנימות פופולריות
export const fetchTopAnimes = createAsyncThunk(
  'animeFeatures/fetchTopAnimes',
  async (_, thunkAPI) => {
    try {
      const data = await animeService.fetchTopAnime()
      return data
    } catch (error) {
      console.error('❌ שגיאה בשליפת אנימות פופולריות:', error)
      return thunkAPI.rejectWithValue(error.message || 'שגיאה לא ידועה')
    }
  }
)

// 🔹 שליפת אנימות קלאסיות
export const fetchClassics = createAsyncThunk(
  'animeFeatures/fetchClassics',
  async (_, thunkAPI) => {
    try {
      const data = await classicsService.fetchClassics()
      return data
    } catch (error) {
      console.error('❌ שגיאה בשליפת אנימות קלאסיות:', error)
      return thunkAPI.rejectWithValue(error.message || 'שגיאה לא ידועה')
    }
  }
)

/* ---------------------------------------------------------- */
/* ---------------------- Slice ----------------------------- */
/* ---------------------------------------------------------- */

const initialState = {
  schedules: {},
  classics: [],
  topAnimes: [],
  loading: {
    schedule: false,
    topAnimes: false,
    classics: false,
  },
  error: null,
}

const animeFeaturesSlice = createSlice({
  name: 'animeFeatures',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* 🔹 לוח שידורים */
    builder
      .addCase(fetchAnimeScheduleByDay.pending, (state) => {
        state.loading.schedule = true
        state.error = null
      })
      .addCase(fetchAnimeScheduleByDay.fulfilled, (state, action) => {
        const { day, data } = action.payload

        if (!data.length) {
          console.warn(`⚠️ אין נתונים עבור ${day}`)
        }

        state.schedules[day] = data
        state.loading.schedule = false
      })
      .addCase(fetchAnimeScheduleByDay.rejected, (state, action) => {
        console.error('❌ שגיאה בלוח השידורים:', action.payload)
        state.loading.schedule = false
        state.error = action.payload
      })

    /* 🔹 אנימות פופולריות */
    builder
      .addCase(fetchTopAnimes.pending, (state) => {
        state.loading.topAnimes = true
        state.error = null
      })
      .addCase(fetchTopAnimes.fulfilled, (state, action) => {
        if (!action.payload.length) {
          console.warn('⚠️ אין נתונים לאנימות פופולריות')
        }

        state.topAnimes = action.payload
        state.loading.topAnimes = false
      })
      .addCase(fetchTopAnimes.rejected, (state, action) => {
        console.error('❌ שגיאה בשליפת אנימות פופולריות:', action.payload)
        state.loading.topAnimes = false
        state.error = action.payload
      })

    /* 🔹 אנימות קלאסיות */
    builder
      .addCase(fetchClassics.pending, (state) => {
        state.loading.classics = true
        state.error = null
      })
      .addCase(fetchClassics.fulfilled, (state, action) => {
        if (!action.payload.length) {
          console.warn('⚠️ אין נתונים לאנימות קלאסיות')
        }

        state.classics = action.payload
        state.loading.classics = false
      })
      .addCase(fetchClassics.rejected, (state, action) => {
        console.error('❌ שגיאה בשליפת אנימות קלאסיות:', action.payload)
        state.loading.classics = false
        state.error = action.payload
      })
  },
})

/* ---------------------------------------------------------- */
/* -------------------- Exports ----------------------------- */
/* ---------------------------------------------------------- */

export const animeFeaturesReducer = animeFeaturesSlice.reducer
